'use client';

import React from 'react';
import CustomSearchBox from '../Search/SearchBox';

interface SearchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SearchModal: React.FC<SearchModalProps> = ({ isOpen, onClose }) => {
  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50" onClick={handleBackdropClick}>
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 mt-10 mx-auto z-50 custom-modal-height"
        onClick={(e) => e.stopPropagation()}
      >
        <CustomSearchBox />
      </div>
    </div>
  );
};

export default SearchModal;
